import fetchStompunkter from './fetchStompunkter'

export default async function fetchHeavyStompunkter(ids, srid) {
	// Stompunkter behöver hämtas i både 3006 (så att vi får koordinater som funkar på kartan)
	// och aktuellt system (så vi får koordinater som kan visas för användaren).
	// Detta är inte jättevackert men det är den bästa lösningen jag kom på.
	// Se HITSTOM-67.
	let heavySystem;
	let lightSystem
	if (srid === 3006) {
		heavySystem = lightSystem = await fetchHeavyStompunkterSingleSystem(ids, srid)
	}
	else {
		[heavySystem, lightSystem] = await Promise.all([
			fetchHeavyStompunkterSingleSystem(ids, srid),
			fetchHeavyStompunkterSingleSystem(ids, 3006)
		])
	}
	return { heavySystem, lightSystem }
}


async function fetchHeavyStompunkterSingleSystem(ids, srid) {
	return fetchStompunkter({
		path: 'id',
		query: { srid },
		body: ids
	})
}



// WEBPACK FOOTER //
// ./src/dataSource/fetchHeavyStompunkter.js